import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  pinky: "/images/characters/pinky.webp",
  dottie: "/images/characters/dottie.webp",
  misty: "/images/characters/misty.webp",
  minty: "/images/characters/minty.webp",
  sunny: "/images/characters/sunny.webp",
  logo: "/images/logo.webp",
};

const characters = [
  {
    name: "Pinky Pop", color: C.pink, soft: C.pinkSoft, img: IMG.pinky,
    pronoun: "she", trait: "Bubbly & Kind", dance: "pinkyPop",
    bio: "Pinky is bubbly, caring and always ready to make new friends. She loves cheering everyone on, spreading positivity and making sure nobody dances alone. With Pinky Pop around, every child feels safe, happy and proud to be themselves.",
    funFacts: [
      { label: "Favourite Move", value: "The Pinky Pop" },
      { label: "Loves", value: "Making everyone smile" },
      { label: "Superpower", value: "Turning shy dancers into stars" },
      { label: "Catchphrase", value: "Let's do this together!" },
    ],
  },
  {
    name: "Sunny Ray", color: C.yellow, soft: C.yellowSoft, img: IMG.sunny,
    pronoun: "he", trait: "Smart & Curious", dance: "sunnySparkle",
    bio: "The bright spark of The Funky Bunch! Sunny is always curious and full of ideas. He loves leading the way, helping everyone feel included and showing children how to listen, try new things and shine with confidence.",
    funFacts: [
      { label: "Favourite Move", value: "The Sunny Sparkle" },
      { label: "Loves", value: "Learning new dances" },
      { label: "Superpower", value: "Making tricky steps feel easy" },
      { label: "Catchphrase", value: "Watch this, everyone!" },
    ],
  },
  {
    name: "Dottie", color: C.blue, soft: C.blueSoft, img: IMG.dottie,
    pronoun: "she", trait: "Playful & Rhythmic", dance: "dizzyDottie",
    bio: "Small but mighty! Dottie loves music, rhythm and copying sounds and movements. Always bouncing to the beat, she helps children tune into music and enjoy learning through repetition and play.",
    funFacts: [
      { label: "Favourite Move", value: "The Dizzy Dottie" },
      { label: "Loves", value: "Clapping along to music" },
      { label: "Superpower", value: "Finding the rhythm in everything" },
      { label: "Catchphrase", value: "Can you hear that beat?" },
    ],
  },
  {
    name: "Minty Wiggle", color: C.mint, soft: C.mintSoft, img: IMG.minty,
    pronoun: "he", trait: "Energetic & Fun", dance: "mintyWiggle",
    bio: "Minty can't sit still, and that's a good thing! With lots of energy and a wobbly, bouncy style, he loves big movements, silly dances and having fun. Minty reminds children that moving feels good and there's no right way to dance.",
    funFacts: [
      { label: "Favourite Move", value: "The Minty Wiggle" },
      { label: "Loves", value: "Silly dances and big jumps" },
      { label: "Superpower", value: "Making everyone giggle" },
      { label: "Catchphrase", value: "Wiggle wiggle wiggle!" },
    ],
  },
  {
    name: "Misty Cloud", color: C.lilac, soft: C.lilacSoft, img: IMG.misty,
    pronoun: "she", trait: "Dreamy & Gentle", dance: "floatingCloud",
    bio: "Misty floats along gently, bringing calm energy and imagination to the group. She loves flowing movements, quiet moments and creative play. Misty shows children that it's okay to slow down, feel their feelings and express themselves in their own way.",
    funFacts: [
      { label: "Favourite Move", value: "The Floating Cloud Sway" },
      { label: "Loves", value: "Dancing with scarves and ribbons" },
      { label: "Superpower", value: "Turning any moment into magic" },
      { label: "Catchphrase", value: "Close your eyes and imagine..." },
    ],
  },
];

const RainbowHeading = ({ children, size = 28 }) => (
  <h2 style={{
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  }}>{children}</h2>
);

/* ═══ NAV (same as homepage) ═══ */
const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Meet The Bunch" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Meet The Bunch" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

/* ═══ FOOTER (same as homepage) ═══ */
const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>
            Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS
          </div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

/* ═══ MAIN PAGE ═══ */
export default function MeetTheBunch() {
  const [active, setActive] = useState(0);
  const char = characters[active];

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes idleWobble {
          0%, 100% { transform: rotate(0deg) scaleX(1) scaleY(1); }
          20% { transform: rotate(-3deg) scaleX(1.02) scaleY(0.98); }
          50% { transform: rotate(3deg) scaleX(0.98) scaleY(1.02); }
          80% { transform: rotate(-2deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes pinkyPop {
          0%, 100% { transform: translateY(0) scaleY(1) scaleX(1); }
          15% { transform: translateY(8px) scaleY(0.85) scaleX(1.1); }
          30% { transform: translateY(10px) scaleY(0.82) scaleX(1.12); }
          45% { transform: translateY(-20px) scaleY(1.15) scaleX(0.9); }
          55% { transform: translateY(-22px) scaleY(1.12) scaleX(0.92); }
          70% { transform: translateY(0px) scaleY(0.92) scaleX(1.06); }
          85% { transform: translateY(-4px) scaleY(1.03) scaleX(0.98); }
        }
        @keyframes sunnySparkle {
          0%, 100% { transform: translateX(0) rotate(0deg) scaleX(1); }
          10% { transform: translateX(-8px) rotate(-5deg) scaleX(1.06); }
          20% { transform: translateX(8px) rotate(5deg) scaleX(0.94); }
          30% { transform: translateX(-6px) rotate(-4deg) scaleX(1.05); }
          40% { transform: translateX(6px) rotate(4deg) scaleX(0.95); }
          50% { transform: translateX(-4px) rotate(-3deg) scaleX(1.04); }
          60% { transform: translateX(4px) rotate(3deg) scaleX(0.96); }
          70% { transform: translateX(-3px) rotate(-2deg) scaleX(1.02); }
          80% { transform: translateX(3px) rotate(2deg) scaleX(0.98); }
          90% { transform: translateX(-1px) rotate(-1deg) scaleX(1.01); }
        }
        @keyframes dizzyDottie {
          0% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(90deg) scale(1.04); }
          50% { transform: rotate(180deg) scale(1); }
          75% { transform: rotate(270deg) scale(1.04); }
          100% { transform: rotate(360deg) scale(1); }
        }
        @keyframes mintyWiggle {
          0%, 100% { transform: translateX(0) rotate(0deg) scaleX(1) scaleY(1); }
          8% { transform: translateX(-5px) rotate(-4deg) scaleX(1.06) scaleY(0.94); }
          16% { transform: translateX(5px) rotate(4deg) scaleX(0.94) scaleY(1.06); }
          24% { transform: translateX(-6px) rotate(-5deg) scaleX(1.07) scaleY(0.93); }
          32% { transform: translateX(6px) rotate(5deg) scaleX(0.93) scaleY(1.07); }
          40% { transform: translateX(-5px) rotate(-4deg) scaleX(1.06) scaleY(0.94); }
          48% { transform: translateX(5px) rotate(4deg) scaleX(0.94) scaleY(1.06); }
          56% { transform: translateX(-4px) rotate(-3deg) scaleX(1.04) scaleY(0.96); }
          64% { transform: translateX(4px) rotate(3deg) scaleX(0.96) scaleY(1.04); }
          72% { transform: translateX(-3px) rotate(-2deg) scaleX(1.03) scaleY(0.97); }
          80% { transform: translateX(3px) rotate(2deg) scaleX(0.97) scaleY(1.03); }
          90% { transform: translateX(-1px) rotate(-1deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes floatingCloud {
          0%, 100% { transform: translateX(0) translateY(0) rotate(0deg); }
          25% { transform: translateX(-8px) translateY(-4px) rotate(-2deg); }
          50% { transform: translateX(0) translateY(-6px) rotate(0deg); }
          75% { transform: translateX(8px) translateY(-4px) rotate(2deg); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes popIn {
          0% { transform: scale(0.8); opacity: 0; }
          60% { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
      `}</style>

      <Nav />

      {/* Hero section */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, #FFF0F5 40%, #F0EAFF 70%, #E8F5FF 100%)`,
        padding: "48px 24px 40px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28}>Meet The Funky Bunch</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 32px", maxWidth: 440,
          }}>
            Five friends who love to dance, play and have fun. Tap each one to get to know them!
          </p>

          {/* Character selector row */}
          <div style={{
            display: "flex", justifyContent: "center", gap: 16, flexWrap: "wrap",
            marginBottom: 8,
          }}>
            {characters.map((c, i) => (
              <div
                key={i}
                onClick={() => setActive(i)}
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  transform: active === i ? "scale(1.1)" : "scale(1)",
                  opacity: active === i ? 1 : 0.6,
                }}
              >
                <div style={{
                  width: active === i ? 100 : 80,
                  height: active === i ? 100 : 80,
                  transition: "all 0.3s ease",
                  animation: active === i ? `${c.dance} ${c.dance === 'dizzyDottie' ? '2s' : '1.6s'} ease-in-out infinite` : "idleWobble 1.8s ease-in-out infinite",
                  animationDelay: `${i * 0.15}s`,
                  transformOrigin: "center bottom",
                }}>
                  <img src={c.img} alt={c.name} style={{
                    width: "100%", height: "100%", objectFit: "contain",
                    filter: `drop-shadow(0 4px 10px ${active === i ? c.color + "66" : "rgba(0,0,0,0.08)"})`,
                  }} />
                </div>
                <div style={{
                  fontFamily: heading, fontWeight: 700,
                  fontSize: active === i ? 13 : 11,
                  color: active === i ? c.color : C.ink + "77",
                  marginTop: 6, transition: "all 0.3s ease",
                }}>{c.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Character detail section */}
      <section key={active} style={{
        padding: "0 24px 56px",
        animation: "fadeSlideIn 0.4s ease",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          {/* Main character card */}
          <div style={{
            background: char.soft,
            borderRadius: 32,
            border: `2px solid ${char.color}30`,
            padding: "40px 36px",
            marginTop: -20,
            position: "relative",
            overflow: "hidden",
          }}>
            {/* Subtle background decoration */}
            <div style={{
              position: "absolute", top: -60, right: -60,
              width: 200, height: 200, borderRadius: "50%",
              background: char.color + "10",
            }} />
            <div style={{
              position: "absolute", bottom: -40, left: -40,
              width: 150, height: 150, borderRadius: "50%",
              background: char.color + "08",
            }} />

            <div style={{
              display: "flex", gap: 36, alignItems: "center",
              flexWrap: "wrap", justifyContent: "center",
              position: "relative", zIndex: 1,
            }}>
              {/* Large character image */}
              <div style={{
                flex: "0 0 auto",
                animation: `${char.dance} ${char.dance === 'dizzyDottie' ? '2s' : char.dance === 'floatingCloud' ? '3s' : '1.6s'} ease-in-out infinite`,
                transformOrigin: "center bottom",
              }}>
                <img src={char.img} alt={char.name} style={{
                  width: 240, height: 240, objectFit: "contain",
                  filter: `drop-shadow(0 8px 24px ${char.color}33)`,
                }} />
              </div>

              {/* Character info */}
              <div style={{ flex: "1 1 300px", minWidth: 280 }}>
                {/* Name */}
                <h3 style={{
                  fontFamily: heading, fontSize: 32, fontWeight: 800,
                  color: C.ink, margin: "0 0 6px",
                }}>
                  {char.name}
                </h3>

                {/* Trait badge */}
                <div style={{
                  display: "inline-block",
                  background: char.color + "33",
                  borderRadius: 20, padding: "5px 16px",
                  fontFamily: heading, fontWeight: 700,
                  fontSize: 13, color: char.color,
                  marginBottom: 16,
                }}>
                  {char.trait}
                </div>

                {/* Bio */}
                <p style={{
                  fontFamily: body, fontSize: 15, color: C.ink + "bb",
                  lineHeight: 1.7, marginBottom: 24,
                }}>
                  {char.bio}
                </p>

                {/* Fun facts grid */}
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                }}>
                  {char.funFacts.map((f, i) => (
                    <div key={i} style={{
                      background: "#fff",
                      borderRadius: 16,
                      padding: "14px 16px",
                      border: `1.5px solid ${char.color}20`,
                      animation: "popIn 0.3s ease",
                      animationDelay: `${i * 0.08}s`,
                      animationFillMode: "both",
                    }}>
                      <div style={{
                        fontSize: 10, fontFamily: body, fontWeight: 700,
                        color: char.color, textTransform: "uppercase",
                        letterSpacing: 0.8, marginBottom: 4,
                      }}>{f.label}</div>
                      <div style={{
                        fontSize: 14, fontFamily: heading, fontWeight: 700,
                        color: C.ink,
                      }}>{f.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Video placeholder */}
          <div style={{
            maxWidth: 480, margin: "32px auto 0",
            background: char.soft,
            borderRadius: 24,
            border: `2px solid ${char.color}25`,
            padding: "28px 24px",
            textAlign: "center",
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%",
              background: char.color + "33",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 12px",
              position: "relative",
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill={char.color} opacity="0.4">
                <path d="M8 5v14l11-7z"/>
              </svg>
              {/* No entry overlay */}
              <div style={{
                position: "absolute", inset: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={char.color} strokeWidth="2" opacity="0.7">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                </svg>
              </div>
            </div>
            <div style={{
              fontFamily: heading, fontWeight: 700, fontSize: 16, color: C.ink,
              marginBottom: 4,
            }}>
              Meet {char.name}
            </div>
            <div style={{
              fontFamily: body, fontSize: 13, color: C.ink + "88",
            }}>
              Video coming soon
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{
        background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.blueSoft})`,
        padding: "48px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22}>Come dance with us</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 14, color: C.ink + "99",
            margin: "8px 0 24px",
          }}>
            The Funky Bunch can't wait to meet you! Book your first class today.
          </p>
          <button style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 36px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 16, cursor: "pointer",
          }} onClick={() => { window.location.hash = "classes"; }}>Book a Class</button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
